var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      { staticClass: "container container-small py-4" },
      [
        _c("Heading", {
          staticClass: "py-4",
          attrs: {
            title: _vm.$t("reset_password_title"),
            routeName: "vignette",
          },
        }),
        !_vm.message.length
          ? [
              _c("div", { staticClass: "form-group" }, [
                _c("label", [_vm._v(_vm._s(_vm.$t("label_password")))]),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.password,
                      expression: "password",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: { type: "password", placeholder: _vm.$t("password") },
                  domProps: { value: _vm.password },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.password = $event.target.value
                    },
                  },
                }),
              ]),
              _c("div", { staticClass: "form-group" }, [
                _c("label", [_vm._v(_vm._s(_vm.$t("label_confirm_password")))]),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.password_confirmation,
                      expression: "password_confirmation",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: {
                    type: "password",
                    placeholder: _vm.$t("password_confirm"),
                  },
                  domProps: { value: _vm.password_confirmation },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.password_confirmation = $event.target.value
                    },
                  },
                }),
              ]),
              _c(
                "button",
                {
                  staticClass: "btn btn-purple mt-3 w-100",
                  on: {
                    click: function ($event) {
                      return _vm.save()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("btn_save")))]
              ),
            ]
          : _vm._e(),
        _vm.message.length
          ? [
              _c("div", { staticClass: "alert alert-success text-center" }, [
                _vm._v(" " + _vm._s(_vm.message) + " "),
              ]),
              _c(
                "div",
                { staticClass: "text-center" },
                [
                  _vm._v(" " + _vm._s(_vm.$t("return_to_login_1")) + " "),
                  _c(
                    "router-link",
                    {
                      staticClass: "custom-link",
                      attrs: { to: { name: "login" } },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("return_to_login_2")) + " ")]
                  ),
                ],
                1
              ),
            ]
          : _vm._e(),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }